import { invitationsAdapterSelectors } from '../redux/slices/invitations';
import { createSelector } from 'reselect';

export const getAll = invitationsAdapterSelectors.selectAll;
const getCurrentWorkspaceinvitationsFromStore = (state) =>
  state.currentWorkspace.invitations;

export const getAcceptedUsersInvitation = createSelector(
  getCurrentWorkspaceinvitationsFromStore,
  (state) => (id) => invitationsAdapterSelectors.selectById(state, id),
  (invitationIds, getInvitationById) =>
    invitationIds.map((invitationId) => getInvitationById(invitationId))
);

export const getPendingUsersInvitation = createSelector(
  getCurrentWorkspaceinvitationsFromStore,
  (state) => (id) => invitationsAdapterSelectors.selectById(state, id),
  (invitationIds, getInvitationById) =>
    invitationIds
      .map((invitationId) => getInvitationById(invitationId))
      .filter((invitation) => invitation?.status === 'sent')
);

export const getCustomerMembersInvitations = createSelector(
  (state) => invitationsAdapterSelectors.selectAll(state),
  (_, customerId) => customerId,
  (invitations, customerId) =>
    invitations.filter(
      (invitation) =>
        invitation.status === 'sent' && invitation.customerId === customerId
    )
);
